/* v8 ignore start */

'use client';

import { useTranslations } from 'next-intl';
import { Drawer } from 'vaul';
import Icon from '@/components/shared/Icon';
import useToggleSmoothScroll from '@/hooks/useToggleSmoothScroll';
import RichText from './RichText';

export default function TextDrawer({
  button,
  content,
  title,
}: {
  button: React.ReactNode;
  content: BlockArray;
  title: string;
}) {
  const t = useTranslations();
  const toggle = useToggleSmoothScroll();

  return (
    <Drawer.Root
      autoFocus
      onOpenChange={(open) => toggle(!open)}
    >
      <Drawer.Trigger asChild>{button}</Drawer.Trigger>

      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-40 bg-black/50 backdrop-blur-xs" />
        <Drawer.Content
          className="!pointer-events-none fixed inset-0 top-auto z-50 mx-auto flex max-w-xl flex-col outline-none lg:top-0 lg:max-w-4xl lg:justify-center"
          aria-describedby={undefined}
        >
          <div className="pointer-events-auto flex max-h-[calc(100dvh-2rem)] flex-col overflow-hidden rounded-t-lg bg-white lg:max-h-[75vh] lg:rounded-b-lg">
            <header className="items-center justify-between gap-5 border-b border-black/10 px-5 pt-4.5 pb-8 sm:px-24 md:px-16 lg:flex lg:px-8 lg:pt-7 lg:pb-5">
              <Drawer.Handle className="!w-15 lg:!hidden" />

              <Drawer.Title className="font-display text-display-2xs lg:text-display-xs mt-8 font-medium uppercase lg:mt-0">
                {title}
              </Drawer.Title>

              <Drawer.Close
                className="hover:text-neutral-10 hidden size-8 shrink-0 items-center justify-center rounded-md bg-black/5 transition-colors hover:bg-black/10 lg:flex"
                aria-label={t('close')}
              >
                <Icon
                  name="times"
                  className="size-3"
                />
              </Drawer.Close>
            </header>

            <div className="relative isolate flex flex-col overflow-hidden">
              <div className="pointer-events-none absolute inset-0 z-10 flex flex-col justify-end bg-gradient-to-t from-black/8 to-25% p-5 lg:hidden">
                <Drawer.Close className="pointer-events-auto relative mx-auto w-full max-w-2xs rounded-full bg-white p-4 font-semibold ring ring-black/8">
                  {t('close')}
                </Drawer.Close>
              </div>

              <div className="overflow-y-auto px-5 pt-10 pb-28 sm:px-24 md:px-16 lg:px-9 lg:py-10">
                <RichText value={content} />
              </div>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
